import {useMutation, useQueryClient} from '@tanstack/react-query';
import Toaster from 'src/app/utilities/helpers/Toaster';
import {parseErrors} from 'src/app/utilities/helpers/errors';
import {
    createBookingOption,
    type BookingOptionFormFields,
} from 'src/data/services/booking-options-service';
import {EVENT_BOOKING_OPTIONS_QUERY_KEY} from './use-fetch-event-booking-options';

const useCreateBookingOption = (onSuccess: () => void) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async ({
                               eventId,
                               bookingOptionData,
                           }: {
            eventId: string;
            bookingOptionData: BookingOptionFormFields[];
        }) => createBookingOption(eventId, bookingOptionData),
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: [EVENT_BOOKING_OPTIONS_QUERY_KEY],
            });
            Toaster.toast('Booking option created successfully', {
                variant: 'success',
            });
            onSuccess();
        },

        onError: (errors) => {
            Toaster.toastErrors(parseErrors(errors));
        },
    });
};

export default useCreateBookingOption;
